import { next_initialize } from '@getcha-dev/boot/next';

next_initialize();

export default {};
